import apiHandler from '../core/apiHandler';

const restaurantUnitConversionApi = apiHandler('restaurant/unit-conversions');

export default restaurantUnitConversionApi;